import type { SVGProps } from 'react'
const LineThumbsUp = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M21.33 9.075A2.74 2.74 0 0 0 19.15 8H15V4.75A2.755 2.755 0 0 0 12.25 2h-1.5c-.69 0-1.25.56-1.25 1.25v3.605L6.815 11.5H2V22h13.355c2.15 0 4.04-1.45 4.59-3.53l1.865-7.015c.22-.83.045-1.7-.48-2.385zM6.5 20.5h-3V13h3zm13.855-9.43-1.865 7.015a3.26 3.26 0 0 1-3.14 2.415H7.995v-8.05l3-5.195V3.5h1.25c.69 0 1.25.56 1.25 1.25V9.5h5.65c.39 0 .75.18.99.49s.315.705.215 1.085z"
		/>
	</svg>
)
export { LineThumbsUp }
